import React from 'react';
import Letters from '../letters.svg';
import './LetterSvg.scss';

const LetterSvg = ({letter, color, size}) => (
    <svg className="svg-letter" fill={color} width={size} height={size}>
        <use href={`${Letters}#letter-${letter}`} />
    </svg>
);

LetterSvg.defaultProps = {
    size: 30,
    color: 'black',
};

export default LetterSvg;
